const decimalsFunction = {
    name: 'decimals',
    constant: true,
    parameters: [],
    returnType: { type: 'Integer', decimals: 0 },
};
export const abi = (decimals) => ({
    functions: [
        {
            name: 'name',
            constant: true,
            parameters: [],
            returnType: { type: 'String' },
        },
        {
            name: 'symbol',
            constant: true,
            parameters: [],
            returnType: { type: 'String' },
        },
        decimalsFunction,
        {
            name: 'totalSupply',
            constant: true,
            parameters: [],
            returnType: { type: 'Integer', decimals },
        },
        {
            name: 'transfer',
            parameters: [
                {
                    type: 'Address',
                    name: 'from',
                },
                {
                    type: 'Address',
                    name: 'to',
                },
                {
                    type: 'Integer',
                    name: 'value',
                    decimals,
                },
            ],
            returnType: { type: 'Boolean' },
        },
        {
            name: 'balanceOf',
            constant: true,
            parameters: [
                {
                    type: 'Address',
                    name: 'account',
                },
            ],
            returnType: { type: 'Integer', decimals },
        },
    ],
    events: [
        {
            name: 'transfer',
            parameters: [
                {
                    type: 'Address',
                    name: 'from',
                    optional: true,
                },
                {
                    type: 'Address',
                    name: 'to',
                    optional: true,
                },
                {
                    type: 'Integer',
                    name: 'amount',
                    decimals,
                },
            ],
        },
    ],
});
export const getDecimals = async (client, networksDefinition, network) => {
    const decimalsBigNumber = await client
        .smartContract({ networks: networksDefinition, abi: { functions: [decimalsFunction] } })
        .decimals({ network });
    return decimalsBigNumber.toNumber();
};
export const createNEP5SmartContract = (client, networksDefinition, decimals) => client.smartContract({
    networks: networksDefinition,
    abi: abi(decimals),
});

//# sourceMappingURL=nep5.js.map
